import React from 'react'
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    Paper
} from '@mui/material/';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ColeccionStep from '../ColeccionStep';

const ModalColeccion = (props) => {

    const {
        abrirModal,
        handleClose, 
        crearColeccion, 
        setNombreColeccion,
        nombreColeccion,
        diagramas,
        setColecciones,
        diagramasColeccion,
        setColorColeccion,
        colorColeccion
    } = props;

    

    return (
        <Dialog
            open={abrirModal}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth
        >
            <DialogContent>
                <ColeccionStep
                    setNombreColeccion={setNombreColeccion}
                    nombreColeccion={nombreColeccion}
                    crearColeccion={crearColeccion}
                    handleClose={handleClose}
                    diagramas={diagramas}
                    setColecciones={setColecciones}
                    diagramasColeccion={diagramasColeccion}
                    setColorColeccion={setColorColeccion}
                    colorColeccion={colorColeccion}
                />
            </DialogContent>

            <DialogActions>
                
            </DialogActions>
        </Dialog>
    )
}

export default ModalColeccion